import { localePath } from '../utils/localePath';

const COLORS = { muted: "#9999b5", accent: "#00e5a0", border: "#1e1e2e" };

const ALL_CALCULATORS = [
  { path: '/credit-card-payoff-calculator/',  label: 'Credit Card Payoff Calculator' },
  { path: '/debt-snowball-calculator/',        label: 'Debt Snowball Calculator' },
  { path: '/debt-avalanche-calculator/',       label: 'Debt Avalanche Calculator' },
  { path: '/debt-repayment-calculator/',       label: 'Debt Repayment Calculator' },
  { path: '/student-loan-payoff-calculator/',  label: 'Student Loan Payoff Calculator' },
  { path: '/personal-loan-payoff-calculator/', label: 'Personal Loan Payoff Calculator' },
  { path: '/car-loan-payoff-calculator/',      label: 'Car Loan Payoff Calculator' },
];

export default function RelatedCalculators({ locale, exclude }) {
  const related = ALL_CALCULATORS.filter(c => c.path !== exclude).slice(0, 4);
  return (
    <div style={{ maxWidth: 680, margin: '0 auto', padding: '0 24px 48px' }}>
      <div style={{ paddingTop: 32, borderTop: `1px solid ${COLORS.border}` }}>
        <p style={{ color: COLORS.muted, fontSize: '0.8rem', marginBottom: 12, letterSpacing: '1px', textTransform: 'uppercase' }}>
          More calculators
        </p>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
          {related.map(c => (
            <a
              key={c.path}
              href={localePath(locale, c.path)}
              style={{ color: COLORS.accent, fontSize: '0.9rem', textDecoration: 'none', padding: '6px 12px', border: `1px solid ${COLORS.border}`, borderRadius: 6 }}
            >
              {c.label}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
